function generateBase64urlRandom(byteLength: number): string {
    const array = new Uint8Array(byteLength);
    crypto.getRandomValues(array);
    let value = "";
    for (const byte of array) {
        value += String.fromCharCode(byte);
    }
    return btoa(value).replace(/\+/gu, "-").replace(/\//gu, "_").replace(/=+$/u, "");
}

async function generateCodeChallenge(verifier: string): Promise<string> {
    const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
    let value = "";
    for (const byte of new Uint8Array(digest)) {
        value += String.fromCharCode(byte);
    }
    return btoa(value).replace(/\+/gu, "-").replace(/\//gu, "_").replace(/=+$/u, "");
}

export async function generateOidcAuthenticationParameters(): Promise<{
    codeChallenge: string;
    codeVerifier: string;
    state: string;
}> {
    const codeVerifier = generateBase64urlRandom(32);
    const state = generateBase64urlRandom(24);
    const codeChallenge = await generateCodeChallenge(codeVerifier);

    return {
        codeChallenge: codeChallenge,
        codeVerifier: codeVerifier,
        state: state,
    };
}
